import { Box, Flex, Heading, HStack } from "@chakra-ui/react";
import { Beta } from "components";

export default function Section({ title, children, isBeta = false, ...props }){
    return(
    <Flex justifyContent="space-between" alignItems="center" my={4} {...props}>
        <Box>
            <HStack>
                <Heading size="sm" children={title} />
                { isBeta && <Beta /> }
            </HStack>
        </Box>
        <Box>{children}</Box>
    </Flex>
    )
}